/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Guides_Try_SampleInputs */

const en_gc_guides_try_sample = /** @type {(inputs: Gc_Guides_Try_SampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the example workbook`)
};

const zh_gc_guides_try_sample = /** @type {(inputs: Gc_Guides_Try_SampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开示例工作簿`)
};

/**
* | output |
* | --- |
* | "Open the example workbook" |
*
* @param {Gc_Guides_Try_SampleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_guides_try_sample = /** @type {((inputs?: Gc_Guides_Try_SampleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Guides_Try_SampleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_guides_try_sample(inputs)
	return zh_gc_guides_try_sample(inputs)
});
export { gc_guides_try_sample as "gc.guides.try_sample" }